import { Component, ElementRef, Input, ViewChild } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { TranslatePipe } from '@ngx-translate/core';


@Component({
  selector: 'app-textarea-field',
  imports: [CommonModule, TranslatePipe, ReactiveFormsModule],
  templateUrl: './textarea-field.html',
  styleUrl: './textarea-field.css'
})
export class TextareaField {
  @Input() label = '';
  @Input() placeholder = '';
  @Input() row = '1';
  @Input() control: FormControl<any> | null = null;
  @Input() maxLength = 250;

  currentLength = 0;
  textLimitExceed = false;

  @ViewChild('textareaEl') textareaEl!: ElementRef<HTMLTextAreaElement>;


  onInput() {
    const value = this.control?.value || '';
    this.currentLength = value.length;
    this.textLimitExceed = this.currentLength >= this.maxLength;

    // Auto-resize logic
    this.adjustHeight();
  }

  ngAfterViewInit() {
    this.adjustHeight();
  }

  private adjustHeight() {
    const textarea = this.textareaEl?.nativeElement;
    if (textarea) {
      textarea.style.height = 'auto'; // Reset first
      textarea.style.height = textarea.scrollHeight + 'px'; // Set new height
    }
  }
}
